// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Bk5y","col":"styles_col__2cdj8"};